const Conditions = {
    FINISH_TASK_OR_QUEST: 'FinishTaskOrQuest',
    COMPLETE_BATTLE: 'CompleteBattle',
    COMPLETE_NEGOTIATION: 'CompleteNegotiation',
};
class ProcCondition {
    __value;
    constructor(value) {
        this.__value = value;
    }
    static asFinishTask() {
        return new this(Conditions.FINISH_TASK_OR_QUEST);
    }
    static asCompleteBattle() {
        return new this(Conditions.COMPLETE_BATTLE);
    }
    static asCompleteNegotiation() {
        return new this(Conditions.COMPLETE_NEGOTIATION);
    }
    toString() {
        switch (this.__value) {
            case Conditions.FINISH_TASK_OR_QUEST:
                return 'task or quest is completed';
            case Conditions.COMPLETE_BATTLE:
                return 'battle is won';
            case Conditions.COMPLETE_NEGOTIATION:
                return 'negotiation is solved';
        }
        throw new Error('Unknown condition');
    }
}
export default ProcCondition;
